// Thin wrapper around the Umami tracker. The script tag only renders in
// production (see application.html.erb), so every call must be guarded —
// in dev/test window.umami is undefined and track() is a no-op.
export function track(event, data) {
  window.umami?.track(event, data)
}
